import { Component, ViewEncapsulation, Input } from '@angular/core';


@Component({
  selector: 'app-section-info',
  templateUrl: 'section-info.component.html',
  styleUrls: [ 'section-info.component.scss' ],
  encapsulation: ViewEncapsulation.None
})

export class SectionInfoComponent {
  @Input() selectedSectionInfo: any;

  /**
   * Creates an instance of SectionInfoComponent.
   * @param {PlessDialogService} dialogService ダイアログサービス
   * @memberof SectionInfoComponent
   */
  constructor(
  ) { }

}
